/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const graph_decrease = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.25 15h-1M.75 15h1M3.252 1.169l9.998 4.54m0 0-.743-1.98m.743 1.98-1.98.743M1.75 15V7.067a.467.467 0 0 1 .467-.467h1.566a.467.467 0 0 1 .467.467V15m-2.5 0h2.5m0 0h2.5m0 0V8.933a.467.467 0 0 1 .467-.466h1.566a.467.467 0 0 1 .467.466V15m-2.5 0h2.5m0 0h2.5m0 0v-3.267a.467.467 0 0 1 .467-.466h1.566a.466.466 0 0 1 .467.466V15m-2.5 0h2.5"
    />
  </svg>
)
export default graph_decrease
